module.exports = __webpack_public_path__ + "static/img/ktcu-cs-competition-proposal.c489496.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/ktcu-cs-competition-proposal.jpg
// module id = 9w/+
// module chunks = 0